var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinSidaGubbe = function SvgMinSidaGubbe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    fill: "none",
    viewBox: "0 0 21 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M14.7 14.25c-1.345 0-1.992.75-4.2.75s-2.85-.75-4.2-.75a6.3 6.3 0 0 0-6.3 6.3v1.2A2.25 2.25 0 0 0 2.25 24h16.5A2.25 2.25 0 0 0 21 21.75v-1.2c0-3.478-2.822-6.3-6.3-6.3m4.05 7.5H2.25v-1.2A4.057 4.057 0 0 1 6.3 16.5c.684 0 1.795.75 4.2.75 2.423 0 3.51-.75 4.2-.75a4.057 4.057 0 0 1 4.05 4.05zM10.5 13.5a6.75 6.75 0 0 0 6.75-6.75A6.75 6.75 0 0 0 10.5 0a6.75 6.75 0 0 0-6.75 6.75 6.75 6.75 0 0 0 6.75 6.75m0-11.25c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5S6 9.23 6 6.75s2.02-4.5 4.5-4.5"
  })));
};
export default SvgMinSidaGubbe;